module.exports = __webpack_public_path__ + "img/green_052.43211ae3.png";